module.exports = __webpack_public_path__ + "static/icon-pc-efcb12f044fd96539de99ab1c8c1136f.png";